/* eslint-disable @typescript-eslint/naming-convention */
import { Breadcrumb, Button, Space } from 'antd'
import styled from 'styled-components'
import { DeleteModal, IconFont, PageContainer } from '@/components'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import TaskInfo from './task-info'
import DetailInfo from './detail'
import { useGetTaskDetail } from './utils'
import { useDeleteTaskExec } from '../task-list/utils'
import { CreateReport } from '@/components/create-report'
import { useAddReport } from '@/pages/evaluation/report-task/utils'
import { t } from '@/i18n'
export interface IDeleteModal {
  visible: boolean
  ids?: string[] | null | undefined
}
export const defaultDelete: IDeleteModal = {
  visible: false,
}

const TaskDetail = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const id = searchParams.get('id') as string
  const task_name = searchParams.get('task_name') as string
  const task_id = searchParams.get('task_id') as string
  const page = searchParams.get('page')
  const limit = searchParams.get('limit')
  const [deleteTask] = useDeleteTaskExec()
  const [taskDetail, getTaskDetail] = useGetTaskDetail()
  const [generateReport, createLoading] = useAddReport()
  const [deleteModal, setDeleteModal] = useState<IDeleteModal>(defaultDelete)
  const [addReport, setAddReport] = useState({ visible: false, result_id: null })
  const [random, setRandom] = useState(0)
  const confirmAddReport = values => {
    generateReport({
      task_list: [{ task_name: task_name, campaign_id: addReport.result_id }],
      ...values,
    })
      .then(_ => {
        window.open('/report/task/task-report?tab=7', '_self')
      })
      .catch(_ => {})
  }

  const handleDeleteTask = async () => {
    try {
      await deleteTask({
        result_id_list: deleteModal.ids,
      }).catch(_ => {})
      setDeleteModal(defaultDelete)
      navigate('/validation/data/dataprotection?tab=task', {
        state: { page, limit },
      })
    } catch (error) {}
  }

  useEffect(() => {
    getTaskDetail({
      result_id: id,
      task_id: task_id,
    }).catch(_ => {})
  }, [])

  const changeDate = val => {
    getTaskDetail({
      task_id: task_id,
      result_id: val,
    }).catch(_ => {})
  }

  return (
    <PageContainer
      contentStyle={{ minHeight: 'calc(100% - 80px)' }}
      crumbs={
        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Button
              style={{
                width: '24px',
                height: '24px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginRight: '12px',
                background: '#fff',
                border: '0px',
              }}
              icon={<IconFont type="icon-fanhui2" style={{ fontSize: '12px' }} />}
              onClick={() => {
                navigate('/validation/data/dataprotection?tab=task', {
                  state: { limit, page },
                })
              }}
            />
            <Breadcrumb>
              <Breadcrumb.Item>{t('任务详情')}</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <Space>
            {![2, 7].includes(taskDetail?.is_finished) && (
              <Button
                type="primary"
                onClick={() => {
                  setAddReport({ result_id: id, visible: true })
                }}
                style={{ marginRight: '2px' }}
              >
                {t('生成报表')}
              </Button>
            )}
            {![2, 7].includes(taskDetail?.is_finished) && (
              <Button
                onClick={() => {
                  setDeleteModal({
                    visible: true,
                    ids: [id],
                  })
                }}
                style={{ marginRight: '2px' }}
                className="delete"
              >
                {t('删除')}
              </Button>
            )}
          </Space>
        </div>
      }
    >
      <TaskDetailContainer>
        <TaskInfo taskInfo={taskDetail} changeDate={changeDate} setRandom={setRandom} />
        <DetailInfo
          taskInfo={taskDetail}
          id={id}
          task_id={task_id}
          random={random}
          changeDate={changeDate}
        />
      </TaskDetailContainer>
      <CreateReport
        visible={addReport.visible}
        templateType={7}
        onConfirm={confirmAddReport}
        createLoading={createLoading}
        onCancel={() => {
          setAddReport({ visible: false, result_id: null })
        }}
      />
      <DeleteModal
        onOk={handleDeleteTask}
        visible={deleteModal.visible}
        title={t('删除任务')}
        text={t('此操作将永久删除该任务,是否继续?')}
        onCancel={() => {
          setDeleteModal(defaultDelete)
        }}
      />
    </PageContainer>
  )
}

export default TaskDetail

const TaskDetailContainer = styled.div`
  width: 100%;
  .task-message {
    display: flex;
    margin-bottom: 18px;
  }
`
